import Layout from '@/views/trade/Layout.vue';

export default {
    path: '/trade',
    component: Layout,
    children: [
        { path: 'dashboard', component: () => import('@/views/trade/TradeOrderDashboard.vue') },
        { path: 'add', component: () => import('@/views/trade/Add.vue') },
    ]
};
